// Color palette for sensor chart lines
export const SENSOR_COLORS = [
  '#e74c3c', '#3498db', '#2ecc71', '#f39c12', '#9b59b6',
  '#1abc9c', '#34495e', '#e67e22', '#95a5a6', '#f1c40f',
  '#8e44ad', '#16a085', '#27ae60', '#2980b9', '#c0392b'
];

// Chart configuration constants
export const CHART_CONFIG = {
  POINT_RADIUS: 2,
  HOVER_POINT_RADIUS: 4,
  LINE_TENSION: 0.1,
  CHART_HEIGHT: '500px',
  MIN_CONTROL_HEIGHT: '45px'
};

// UI text constants
export const UI_TEXT = {
  PAGE_TITLE: 'Sensor Chart',
  SELECT_PLACEHOLDER: 'Select one or more sensors...',
  NO_OPTIONS_MESSAGE: 'No sensors available',
  NO_SENSORS_TITLE: 'Select sensors to start monitoring',
  NO_SENSORS_SUBTITLE: 'Choose one or more sensors from the dropdown above to see real-time data.',
  NO_SENSORS_INFO: 'No MQTT connection will be established until sensors are selected.',
  WAITING_FOR_DATA_TITLE: 'Waiting for data...',
  LISTENING_MESSAGE: 'Listening for MQTT messages...',
  PAUSED_MESSAGE: 'Data logging is paused'
};

// Chart tooltip and label configurations
export const CHART_LABELS = {
  DATA_POINT_TITLE: 'Data Point',
  X_AXIS_TITLE: 'Data Point Index',
  Y_AXIS_TITLE: 'Value',
  REAL_TIME_TITLE_PREFIX: 'Real-time Sensor Data - Unit'
};

// Button and control labels
export const CONTROL_LABELS = {
  CLEAR_ALL: 'Clear All',
  PAUSE: 'Pause',
  RESUME: 'Resume',
  CLEAR_DATA: 'Clear Data',
  WATER_FLUSH: '💧 Water Flush',
  WATER_FLUSH_TOOLTIP: 'Activate Water Flush'
};

// Select dropdown group labels
export const SENSOR_GROUP_LABELS = {
  CONDUCTIVITY: 'Conductivity',
  COLOR8: 'Color 8-Band',
  COLOR3: 'Color 3-Band',
  ACCELEROMETER: 'Accelerometer',
  LIQUID_SENSOR: 'Liquid Sensor',
  OTHER: 'Other'
};

// Badge labels and status
export const STATUS_LABELS = {
  AVAILABLE: 'available',
  SELECTED: 'selected',
  CONNECTED: 'Connected',
  DISCONNECTED: 'Disconnected',
  RECORDING: 'Recording',
  PAUSED: 'Paused',
  DATA_POINTS: 'data points'
};

// React Select custom styles
export const SELECT_STYLES = {
  control: (provided) => ({
    ...provided,
    minHeight: CHART_CONFIG.MIN_CONTROL_HEIGHT
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#6c757d'
  })
};

// Default chart options factory function
export const createChartOptions = (unitId, selectedSensors, visibleSensors, setVisibleSensors) => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'top',
      onClick: (e, legendItem) => {
        const sensorName = selectedSensors[legendItem.datasetIndex]?.sensor.sensor;
        if (sensorName) {
          setVisibleSensors(prev => {
            const newSet = new Set(prev);
            if (newSet.has(sensorName)) {
              newSet.delete(sensorName);
            } else {
              newSet.add(sensorName);
            }
            return newSet;
          });
        }
      }
    },
    title: {
      display: true,
      text: `${CHART_LABELS.REAL_TIME_TITLE_PREFIX} ${unitId}`
    },
    tooltip: {
      mode: 'index',
      intersect: false,
      callbacks: {
        title: (tooltipItems) => {
          return `${CHART_LABELS.DATA_POINT_TITLE}: ${tooltipItems[0].parsed.x}`;
        },
        label: (context) => {
          return `${context.dataset.label}: ${context.parsed.y.toFixed(2)}`;
        }
      }
    }
  },
  scales: {
    x: {
      type: 'linear',
      title: {
        display: true,
        text: CHART_LABELS.X_AXIS_TITLE
      },
      ticks: {
        stepSize: 1,
        callback: function(value) {
          return Math.floor(value);
        }
      }
    },
    y: {
      title: {
        display: true,
        text: CHART_LABELS.Y_AXIS_TITLE
      },
      grid: {
        color: 'rgba(0,0,0,0.1)'
      }
    }
  },
  interaction: {
    mode: 'nearest',
    axis: 'x',
    intersect: false
  }
});